webpackJsonp([43363949817824],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/matt-turnbull-cartoon-240.f53e0f3e.png";

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _ArrowRight = __webpack_require__(34);
	
	var _ArrowRight2 = _interopRequireDefault(_ArrowRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var EmailPlease = function EmailPlease(_ref) {
		var _ref$list = _ref.list,
		    list = _ref$list === undefined ? "default" : _ref$list,
		    id = _ref.id,
		    _ref$hideFooter = _ref.hideFooter,
		    hideFooter = _ref$hideFooter === undefined ? false : _ref$hideFooter;
		return React.createElement(
			"div",
			null,
			React.createElement(
				"form",
				{ action: getFormAction(list), method: "post", className: "flex items-center mt-4" },
				React.createElement(
					"div",
					{ className: "flex-1" },
					React.createElement("input", {
						type: "email",
						name: "EMAIL",
						placeholder: "Enter your email",
						className: "input w-full border-turtle border-r-0 rounded-r-none"
					})
				),
				React.createElement(
					"div",
					{ className: "w-12 flex" },
					React.createElement(
						"button",
						{
							name: "subscribe",
							type: "submit",
							className: "button border-turtle border-l-0 w-full rounded-l-none shadow"
						},
						React.createElement(
							"div",
							{ className: "flex justify-center" },
							React.createElement(_ArrowRight2.default, { className: "w-4 h-4" })
						)
					)
				),
				id && React.createElement("input", { type: "hidden", name: "ID", value: id })
			),
			!hideFooter && React.createElement(
				"div",
				{ className: "text-xs text-center pt-2 text-turtle-darker" },
				"I know, emails suck. I promise to send only quality stuff. And if not, just unsubscribe!"
			)
		);
	};
	
	exports.default = EmailPlease;
	
	
	function getFormAction(list) {
		var listId = getListId(list);
		return "https://iamturns.us17.list-manage.com/subscribe/post?u=5d5780fe2d3de49f7c38306f2&amp;id=" + listId;
	}
	
	function getListId(list) {
		switch (list) {
			case "doing-javascript":
				return "bdea2a1aea";
			case "javascript-roundup":
				return "970fb402d2";
			case "default":
			default:
				return "46266d5c5e";
		}
	}
	module.exports = exports["default"];

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _EmailPlease = __webpack_require__(42);
	
	var _EmailPlease2 = _interopRequireDefault(_EmailPlease);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _EmailPlease2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _mattTurnbullCartoon = __webpack_require__(136);
	
	var _mattTurnbullCartoon2 = _interopRequireDefault(_mattTurnbullCartoon);
	
	var _mattTurnbullCartoon3 = __webpack_require__(137);
	
	var _mattTurnbullCartoon4 = _interopRequireDefault(_mattTurnbullCartoon3);
	
	var _Link = __webpack_require__(6);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaceLink = function FaceLink(_ref) {
		var _ref$size = _ref.size,
		    size = _ref$size === undefined ? 120 : _ref$size;
		return React.createElement(
			_Link2.default,
			{ to: "/about/" },
			React.createElement("img", {
				src: _mattTurnbullCartoon2.default,
				srcSet: _mattTurnbullCartoon4.default + " 2x",
				alt: "Matt Turnbull",
				width: size,
				height: size,
				className: (0, _classnames2.default)("block rounded-full", "border-2 border-turtle-darker", "hover:grow-sm transition-slow")
			})
		);
	};
	
	exports.default = FaceLink;
	module.exports = exports["default"];

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _FaceLink = __webpack_require__(85);
	
	var _FaceLink2 = _interopRequireDefault(_FaceLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FaceLink2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = exports.frontmatter = undefined;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _ArrowLeft = __webpack_require__(24);
	
	var _ArrowLeft2 = _interopRequireDefault(_ArrowLeft);
	
	var _EmailPlease = __webpack_require__(82);
	
	var _EmailPlease2 = _interopRequireDefault(_EmailPlease);
	
	var _FaceLink = __webpack_require__(86);
	
	var _FaceLink2 = _interopRequireDefault(_FaceLink);
	
	var _HeadTagsContent = __webpack_require__(23);
	
	var _HeadTagsContent2 = _interopRequireDefault(_HeadTagsContent);
	
	var _ImgBlock = __webpack_require__(26);
	
	var _ImgBlock2 = _interopRequireDefault(_ImgBlock);
	
	var _Link = __webpack_require__(6);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _PageContainer = __webpack_require__(11);
	
	var _PageContainer2 = _interopRequireDefault(_PageContainer);
	
	var _image = __webpack_require__(32);
	
	var _hose = __webpack_require__(604);
	
	var _hose2 = _interopRequireDefault(_hose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var IMG_HOSE = (0, _image.createImage)(_hose2.default, 295, 288);
	
	var frontmatter = exports.frontmatter = {
		type: "page",
		title: "JavaScript Roundup",
		description: "A free weekly email powered by the JavaScript community.",
		dateCreated: "2018-07-11",
		dateUpdated: "2018-07-11",
		unlisted: true
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	
	var ContentJavascriptRoundup = function ContentJavascriptRoundup(_ref) {
		var currentContent = _ref.data.currentContent;
		return React.createElement(
			"div",
			null,
			React.createElement(_HeadTagsContent2.default, { content: currentContent }),
			React.createElement(
				_PageContainer2.default,
				{ small: true, className: "wysiwyg" },
				React.createElement(
					"h2",
					null,
					"It\u2019s impossible to keep up with JavaScript."
				),
				React.createElement(
					"p",
					null,
					"Your buddy Slacks you a post:",
					" ",
					React.createElement(
						"span",
						{ className: "underline" },
						"What\u2019s New In React This Month"
					)
				),
				React.createElement(
					"p",
					null,
					"A popular dev tweets: ",
					React.createElement(
						"span",
						{ className: "underline" },
						"Why Aren\u2019t You Using Vue Yet?!"
					)
				),
				React.createElement(
					"p",
					null,
					"And your inbox is jam-packed with fresh articles:",
					" ",
					React.createElement(
						"span",
						{ className: "underline" },
						"You Must Learn Redux Now!"
					),
					" and",
					" ",
					React.createElement(
						"span",
						{ className: "underline" },
						"Redux Is Dead!"
					)
				),
				React.createElement(
					"p",
					null,
					"It\u2019s overwhelming. There\u2019s too much to know."
				),
				React.createElement(
					"h2",
					null,
					"But you\u2019re doing your best to keep up, right?"
				),
				React.createElement(
					"p",
					null,
					"This fast-paced JavaScript industry demands it!"
				),
				React.createElement(
					"p",
					null,
					"So you\u2019re catching up every chance you get. Scrolling\u2026 reading\u2026 refreshing\u2026 skimming. You\u2019re lost in 42 browser tabs of articles, tutorials, and GitHub repos."
				),
				React.createElement(
					"p",
					null,
					"You bookmark a handful to check out later (or, never)."
				),
				React.createElement(
					_ImgBlock2.default,
					{ image: IMG_HOSE },
					"Just checking the latest JavaScript news"
				),
				React.createElement(
					"h2",
					null,
					"I developed a system that easily keeps me up-to-date with JavaScript."
				),
				React.createElement(
					"ol",
					{ className: "pl-4" },
					React.createElement(
						"li",
						null,
						"Every Sunday I visit the biggest news platforms (like Hacker News, Twitter, and Medium)."
					),
					React.createElement(
						"li",
						null,
						"I run filters to discover the most popular JavaScript content from the last 7 days."
					),
					React.createElement(
						"li",
						null,
						"I collate, de-dupe, tag, and save the results into a report."
					)
				),
				React.createElement(
					"h2",
					null,
					"This report is my single source of JavaScript news for the week."
				),
				React.createElement(
					"p",
					null,
					"It surfaces the best content from the biggest JavaScript communities, and contains everything I need to stay updated. Even a quick skim of the report keeps me in the loop."
				),
				React.createElement(
					"p",
					null,
					"The secret sauce: the JavaScript community itself filters the endless flood of news for me. I\u2018ve stopped wasting time refreshing Hacker News twice a day. My inbox feels lighter after ditching a bunch of newsletters. I ignore the noise and simply focus on the report."
				),
				React.createElement(
					"p",
					null,
					"I\u2019ve decided to publish this report every week. Introducing\u2026"
				)
			),
			React.createElement(
				_PageContainer2.default,
				{ className: "my-4 mt-12 p-6 bg-denim-white text-center" },
				React.createElement(
					"h1",
					{ className: "h2 my-0" },
					"JavaScript Roundup"
				),
				React.createElement(
					"p",
					{ className: "p mb-0" },
					"A free weekly email powered by the JavaScript community"
				)
			),
			React.createElement(
				_PageContainer2.default,
				{ small: true, className: "wysiwyg" },
				React.createElement(
					"p",
					null,
					"I know, emails suck. But this one is unique:",
					React.createElement(
						"ul",
						null,
						React.createElement(
							"li",
							null,
							"Powered by the JavaScript community itself.",
							React.createElement(
								"div",
								{ className: "text-sm" },
								"(no hidden agendas)"
							)
						),
						React.createElement(
							"li",
							null,
							"Surfaces only the best from the biggest online platforms.",
							React.createElement(
								"div",
								{ className: "text-sm" },
								"(like Hacker News, Twitter, Medium, GitHub, Reddit, and YouTube)"
							)
						),
						React.createElement(
							"li",
							null,
							"Includes a mix of formats, whatever your preference.",
							React.createElement(
								"div",
								{ className: "text-sm" },
								"(like articles, tutorials, discussions, code, tweets, videos, and podcasts)"
							)
						),
						React.createElement(
							"li",
							null,
							"Monitors major releases of popular tools.",
							React.createElement(
								"div",
								{ className: "text-sm" },
								"(like Node, VS Code, TypeScript, Babel, Next, and Gatsby)"
							)
						),
						React.createElement(
							"li",
							null,
							"Curated and summarised for skimming.",
							React.createElement(
								"div",
								{ className: "text-sm" },
								"(my goal: a few minutes of skimming should keep you updated)"
							)
						)
					)
				),
				React.createElement(
					"p",
					null,
					"Delivered weekly for free. No spam. Unsubscribe anytime."
				),
				React.createElement(
					"div",
					{ className: "my-4" },
					React.createElement(_EmailPlease2.default, { list: "javascript-roundup", id: "javascript-roundup", hideFooter: true })
				),
				React.createElement(
					"aside",
					{ className: "mt-12" },
					React.createElement(
						"div",
						{ className: "inline-flex flex-row items-center" },
						React.createElement(
							"div",
							{ className: "pr-6 flex-none" },
							React.createElement(_FaceLink2.default, { size: 80 })
						),
						React.createElement(
							"div",
							null,
							"Questions, suggestions, feedback?",
							React.createElement("br", null),
							React.createElement(
								_Link2.default,
								{ to: "https://twitter.com/iamturns" },
								"@iamturns"
							),
							" or",
							" ",
							React.createElement(
								_Link2.default,
								{ to: "mailto:matt@iamturns.com" },
								"matt@iamturns.com"
							)
						)
					)
				),
				React.createElement(
					"p",
					{ className: "my-12" },
					React.createElement(
						_Link2.default,
						{ to: "/", className: "button inline-flex items-center" },
						React.createElement(_ArrowLeft2.default, { className: "w-4 h-4 mr-1" }),
						"Back to I Am Turns"
					)
				)
			)
		);
	};
	
	exports.default = ContentJavascriptRoundup;

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hose.35f0c087.gif";

/***/ })

});


// WEBPACK FOOTER //
// component---src-content-javascript-roundup-content-javascript-roundup-js-2053d7cb0040adc8237f.js